module.exports = __webpack_public_path__ + "static/media/smart-filter-bg-problem.bb6f8e2e.svg";